<template>
  <div class="warning-left d-flex">
    <div class="warning-left__inner d-flex flex-nowrap px-1 py-1 ">
      <div class="warning-icon-wrapper">
        <CooperationIcon class="warning-icon"/>
      </div>
      <div class="warning-left__heading">
        <div class="warning-left__title">Kooperation</div>
        <div class="warning-left__subtitle">beenden</div>
      </div>
    </div>
  </div>
</template>

<script>
import CooperationIcon from "@/components/icons/CooperationIcon";

export default {
  name: "WarningLeftExample",
  components: {CooperationIcon}
}
</script>

<style scoped lang="scss">
.warning-left {
  font-size: 14px;

  .warning-icon-wrapper {
    background-color: map-get($grey, 'dark');
    border-radius: 50%;
    display: flex;
    margin-top: 4px;
    margin-right: 24px;
    flex: 0 0 32px;
    width: 32px;
    height: 32px;

    .warning-icon {
      margin: auto;
      height: 50%;
      width: 50%;
    }
  }

  &__title {
    color: map-get($green, 'darken-1');
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
  }

  &__subtitle {
    line-height: 17px;
  }

  // Dark variant
  &.dark {
    padding-right: $spacer*2;

    .warning-left {
      color: $white;

      &__inner {
        background-color: map-get($grey, 'dark');
        width: 100%;
      }

      &__title {
        color: $white;
      }

      &__subtitle {
        color: $white;
      }
    }
  }
}
</style>

<style lang="scss">
.warning-left {
  .warning-icon-wrapper {
    .warning-icon {
      .a {
        stroke: $white;
      }
    }
  }
}
</style>
